import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class CreateMailboxForm {
  public server: string = '';
  public websiteId: number = -1;

  public rules: { [name: string]: FormValidationFunction[] } = {
    server: [
      (v: string) => !!v || 'Server is required!',
    ],
    websiteId: [
      (v: number) => !!v || 'Website is required!',
    ],
  };
}
